import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import moment from "moment";
import { useTranslation } from "react-i18next";

export default function ProjectDatesModal({
  isModalOpen,
  toggleModal,
  project,
}) {
  const { t } = useTranslation();

  if (!isModalOpen) return null;

  const dates = [
    { label: t("startingDate"), value: project?.projectStartingDate },
    { label: t("endingDate"), value: project?.projectEndingDate },
    { label: t("projectExtensionDate"), value: project?.projectExtensionDate },
    { label: t("versionStartingDate"), value: project?.versionStartingDate },
    { label: t("versionEndingDate"), value: project?.versionEndingDate },
  ];

  return (
    <Modal isOpen={isModalOpen} toggle={() => toggleModal(false)}>
      <ModalHeader>Progetto: {project?.projectCode}</ModalHeader>
      <ModalBody>
        <Form>
          {dates.map(({ label, value }) => (
            <FormGroup row key={label}>
              <Label xs={6}>{label}</Label>
              <Col xs={6}>
                <Input
                  value={value ? moment(value).format("DD-MM-YYYY") : "—"}
                  disabled
                />
              </Col>
            </FormGroup>
          ))}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => toggleModal(false)}>OK</Button>
      </ModalFooter>
    </Modal>
  );
}
